var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ButtonGroup',{attrs:{"options":_vm.sizesWithLabels,"value":_vm.currentButtonSize,"label":"Size"},on:{"update":_vm.update}})
}
var staticRenderFns = []

export { render, staticRenderFns }